<template>
  <div class="home">
   <div class="HeaderTop">        
        <div class="logo fadeInLeft">   
       <div class="slogo " > 
         <div class="slo">           
         <img src="../assets/img/logo.png" alt=""  class="img2" />
         <div class="ttt"> B·M</div>
         </div>
         </div>       
        </div>
        <div class="flexright">
          <div class="navbtn fadeInRight" @click="Login">
          <span>{{userWallet?userWallet :$t("链接钱包") |yingcang}}</span>
        </div>
        <div class="loginOut fadeInUp" v-if="outShow" @click="toOut">
          <div class="item">{{$t('退出登陆')}}</div>
        </div>
        <div class="lang" >
          <div class="bbox" @click="langOpen">
          <img :src="lang.icon" alt="" class="limg">
          <div class="ttl" >{{lang.show}}</div>
         </div>        
        </div>
         <div class="i18npor fadeInUp" v-if="langShow">
        <div class="item" v-for="(item,i) in langs" :key="i" @click="onSelectLang(item)">
          <div class="img">
            <img :src="item.icon" alt="" >
          </div>          
          <div class="txt">{{item.text}}</div>
          
        </div>
     </div>        
       </div>
      </div>

 <div class="content">    
  <div  id="section1"></div>  
    <div class="shome" >
      <div class="cardBox fadeInUp">
        <div class="logo" v-observe-visibility="visibilityChanged0">
           <img src="../assets/img/vlog.gif" alt=""  class="img" />
          
        </div>
        <div class="stitle">
          {{$t('宝马聚合生态')}}
        </div>
        <div class="tips">{{$t("以宝马为核心通证，打造通缩加应用双重价值驱动")}}</div>
      <div class="tips">{{$t("宝马应用涵盖:燃烧分红、NFT分红、生态销毁、模式裂变、Defi底池、社区联盟等一站式服务平台")}}</div>
      <div class="slist"  >
        <div class="item fadeUpDown">
          <div class="laber">{{$t('BM价格')}}</div>
          <div class="num">${{(bmprace*1).toFixed(5)}}</div>
          <div class="img">
                <img src="../assets/img/logo.png" alt=""  class="img" />
       </div>
        </div>

          <div class="item cent fadeUpDown">
          <div class="laber">{{$t('流通总量')}}</div>
          <div class="num">{{(1000000000-bmDead).toFixed(0)}}</div>
          <div class="img">
                <img src="../assets/img/logo.png" alt=""  class="img" />
       </div>
        </div>
          <div class="item fadeUpDown">
          <div class="laber">{{$t('销毁总数')}}</div>
          <div class="num">{{bmDead}}</div>
          <div class="img">
                <img src="../assets/img/logo.png" alt=""  class="img" />
       </div>
        </div>
      </div>
    </div>
 </div>
 <div id="section2" :class="activeTabs==1?'m100':''" ></div>
     <div class="title " :class="activeTabs!=1?'m24':''" >{{$t('节点认购')}}</div>
     <!-- 节点认购 -->
     
     <div class="card bg1" >
      <div class="box" >
        <img src="../assets/img/logo.png" class="node" alt="" srcset="" />
         <div class="ctop">
              <div class="name">{{$t('宝马节点')}}</div>
              <div class="txt">{{$t('认购金额')}}</div>
              <div class="price cor2">
                <span class="num">{{500||'...'}}</span> <span class="dw">/USDT</span>
              </div>
              <div class="snum">{{$t('剩余数量')}}：{{nodeNum||'...'}} / 300</div>
            </div>
        <div class="perless">
           {{$t('认购进度')}}：{{nodelv}}%
        </div>
        <div class="alines"><div class="act" :style="{'width':nodelv+'%'}"></div></div>
      </div>
      <div class="buttom" v-observe-visibility="visibilityChanged1">
        <van-button
        :loading="loading"
        v-if="userInfo.nodeLevel==0"
          type="primary"
           @click="toBuyNode"
          loading-text="MINT..."
          class="btn act" >
          {{$t('立即认购')}}</van-button
        >
        <div class="btns" v-if="userInfo.nodeLevel==1"  >{{$t('您已参与节点认购')}} </div>
      </div>
     </div>

  <!-- lp -->
  <div class="card m60" v-if="false">
      <div class="titles t24">PancakeV2{{$t('流动池信息')}}</div>
       <div class="box">
           <div class="cont">
          <div class="lpbox">
            <div class="laber">{{$t("宝马")}} LP</div>
         <div class="nums" @click="upData">
            <div class="tt">{{bmlp}}</div>  
            <img src="../assets/img/sx_ico.png"  alt="usdt" class="ico">
            </div>
           
          </div>
        </div>
           <div class="cont">
          <div class="lpbox">
            <div class="laber">{{$t("劳斯莱斯")}} LP</div>
          <div class="nums" @click="upDatas">
            <div class="tt">{{wdlp}}</div>  
            <img src="../assets/img/sx_ico.png" alt="usdt" class="ico">
            </div>           
          </div>
        </div>
       </div>
     </div>    


  <div  id="section3" :class="activeTabs==2?'m100':''" ></div>
  <div class="title" >{{$t('捐赠')}}</div>

<!-- 捐赠 -->
<div class="card">
      <div class="titles t24">{{$t('捐赠')}}</div>
       <div class="box">
          <div class="cont">
         <div class="ibox brlu">
          <div class="txts">{{$t('捐赠池')}}</div>
          <div class="rbox">
            <div class="num">{{dexc(tools)||0}}</div>
            <div class="txt">BM</div>
            <img src="../assets/img/logo.png" alt="" srcset="" class="ico">
          </div>
         </div>
        </div>
         
      </div>
      <div class="banner">
          <img src="../assets/img/bmbg.gif" alt="" srcset="" class="img">
      </div>
      <div class="box">
        <div class="cont">
          <div class="input">
            <input type="text" class="yinput" v-model="xzNum" placeholder="0.0">
            <div class="dw">
            <div class="tt">USDT</div>  
            <img src="../assets/img/usdt.png" alt="usdt" class="ico">
            </div>
           
          </div>
        </div>
        <div class="cont">
          <div class="left"></div>
          <div class="left">≈ {{bmprace?(xzNum/bmprace).toFixed(4):0}} BM</div>
        </div>
          
      </div>
    
         <!---->
      <div class="buttom" v-observe-visibility="visibilityChanged2">
        <van-button
          :loading="loading"
          type="primary"
          class="btn"
          @click="toBuy()"
        :class="xzNum>0?'act':''" >
          {{$t('确认')}}</van-button
        ></div>
        <div class="box">
           <div class="cont">
          <div class="left">{{$t('今日已投入')}}</div>
          <div class="left"> {{userInfo?userInfo.userDayBuy:0}} USDT</div>
        </div>
         <div class="cont m10">
          <div class="left">{{$t('今日可投入')}}</div>
          <div class="left"> {{dayLimit||0}} USDT</div>
        </div>
          <div class="balance">{{$t('当前余额')}}:</div>
          <div class="cont m10 ">
          <div class="icos"> <img src="../assets/img/logo.png" alt="" srcset="" class="ico"></div>
          <div class="rbox">       
            <div class="num">{{(mybm*1).toFixed(6)}}</div>
              <div class="txt mm">BM </div>           
          </div>
        </div>
           <div class="cont m10 ">        
          <div class="icos"> <img src="../assets/img/usdt.png" alt="" srcset="" class="ico"></div>
          <div class="rbox">
            <div class="num">{{(myusdt*1).toFixed(6)}}</div>
              <div class="txt">USDT </div>            
          </div>
        </div> 
        
      </div>
     </div>
<!-- 我的捐赠 -->
<div class="card">
      <div class="titles">{{$t('我的捐赠')}}</div>
      <div class="box">
          <div class="cont " >         
         <div class="ibox brlu">
          <div class="txts">{{$t('我的捐赠')}}</div>
          <div class="rbox">
            <div class="num">{{userInfo.totalInvest||0}}</div>
            <div class="txt">USDT</div>   
               <img src="../assets/img/usdt.png" alt="" srcset="" class="ico">        
          </div>
          <div class="jz">{{$t('发放进度')}}：{{userInfo.rewardlv}} % </div>
          <div class="alines"><div class="act"  :style="{'width':userInfo.rewardlv+'%'}"></div></div>
         </div>
         
        </div>
          <div class="cont">
         <div class="ibox">
          <div class="txts">{{$t('我的权重')}}</div>
          <div class="rbox">
            <div class="num">{{userInfo.weight||0}} </div>
          </div>
         </div>
        </div>
        <div class="cont">
         <div class="ibox">
          <div class="txts">{{$t('总权重')}}</div>
          <div class="rbox">
            <div class="num">{{totalWeight||0}}</div>
          </div>
         </div>
        </div>
        <div class="cont">
         <div class="ibox">
          <div class="txts">{{$t('已领结算奖励')}}</div>
          <div class="rbox">
            <div class="num">{{userInfo.tReward||0}}</div>
            <div class="txt">USDT</div>
            <img src="../assets/img/usdt.png" alt="" srcset="" class="ico">
          </div>
         </div>
        </div>
        <div class="cont">
         <div class="ibox">
          <div class="txts">{{$t('可领取奖励')}}</div>
          <div class="rbox">
            <div class="num">{{userInfo.sReward||0}}</div>
            <div class="txt">BM</div>
            <img src="../assets/img/logo.png" alt="" srcset="" class="ico">
          </div>
          <div class="btngroup">
            <div class="btns" @click="toLqShow(userInfo.sReward,1)">{{$t('领取')}}</div>
          </div>  
         </div>
        </div>
          <div class="cont">
         <div class="ibox">
          <div class="txts">{{$t('等级奖励')}}</div>
          <div class="rbox">
            <div class="num">{{userInfo.lReward||0}}</div>
            <div class="txt">BM</div>
            <img src="../assets/img/logo.png" alt="" srcset="" class="ico">
          </div>
          <div class="btngroup">
            <div class="btns" @click="toLqShow(userInfo.lReward,2)">{{$t('领取')}}</div>
          </div>  
         </div>
        </div>
         <div class="cont">
         <div class="ibox">
          <div class="txts">{{$t('节点奖励')}}</div>
          <div class="rbox">
            <div class="num">{{userInfo.nReward||0}}</div>
            <div class="txt">BM</div>
            <img src="../assets/img/logo.png" alt="" srcset="" class="ico">
          </div>
          <div class="btngroup">
            <div class="btns" @click="toLqShow(userInfo.nReward,3)">{{$t('领取')}}</div>
          </div>  
         </div>
        </div>
      </div>
     </div>
       <div id="section4" :class="activeTabs==3?'m100':''" ></div>
       <div class="title" >{{$t('我的')}}</div>
 <div class="card">
      <div class="titles">{{$t('我的邀请链接')}}</div>
      <div class="yqbox">
        <div class="link" >{{codeWallet}}</div>      
      </div>  
      <div class="buttom">
        <button
            type="button"
            class="fuzhi btn act"
            v-clipboard:copy="codeWallet"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
          {{$t('复制')}}
          </button>     
      </div>   
      <div class="box" v-observe-visibility="visibilityChanged3">
        <div class="cont">
         <div class="ibox">
          <div class="txts">{{$t('我的推荐人')}}</div>
          <div class="rbox">
            <div class="txt">{{userInfo.referrer | yingcang}}</div>
          </div>
         </div>
        </div></div>  
     </div>
<!-- 预约订单记录 -->
<div class="card">
      <div class="titles" >{{$t('我的社区')}} </div>
      <div class="box">
        <div class="tips">{{$t('共同掀起DeFi新浪潮')}}!</div>
       <div class="cont">
         <div class="ibox" >
          <div class="txts">{{$t('当前等级')}}</div>
          <div class="rbox">
            <div class="num">V {{userInfo.userLevel||0}}</div>
          </div>
         </div>
        </div>
        <div class="cont">
         <div class="ibox" >
          <div class="txts">{{$t('个人业绩')}}</div>
          <div class="rbox">
            <div class="num">{{userInfo.totalInvest||0}}</div>
            <div class="txt">USDT</div>
            <img src="../assets/img/usdt.png" alt="" srcset="" class="ico">
          </div>
         </div>
        </div>
        <div class="line"></div>
        <div class="cont">
         <div class="ibox" >
          <div class="txts">{{$t('团队总业绩')}}</div>
          <div class="rbox">
            <div class="num">{{userInfo.communityPerformance||0}}</div>
            <div class="txt">USDT</div>
            <img src="../assets/img/usdt.png" alt="" srcset="" class="ico">
          </div>
         </div>
        </div>
        <div class="cont">
         <div class="ibox">
          <div class="txts">{{$t('小市场业绩')}}</div>
          <div class="rbox">
            <div class="num">{{userInfo.subCommunityPerformance||0}}</div>
            <div class="txt">USDT</div>
            <img src="../assets/img/usdt.png" alt="" srcset="" class="ico">
          </div>
         </div>
        </div>
        
      </div>  
     </div>


     <div class="card" >
      <div class="titles">{{$t('我的直推')}}</div>
      <div class="list">
        <div class="items" v-for="(item,i) in list" :key="i">
          <div class="tops" @click="toshow(i,item.show)">
          <div class="sord">{{i+1}} | </div>
          <div class="address">{{item.userAddress| yingcang}}</div>
          <div class="num">{{dexc(item.totalInvest)}} <span class="dw">USDT</span></div>
         </div>
         <div class="bottoms fadeInUp" v-if="item.show">
           <div class="line ">            
            <div class="left">{{ $t("节点等级") }}  </div>
            <div class="right">{{ item.nodeLevel>0?$t("宝马节点"):$t("无")}}</div>
            </div>
           <div class="line ">            
            <div class="left">{{ $t("用户等级") }}  </div>
            <div class="right">V{{ item.userLevel>0?item.userLevel:'0' }}</div>
            </div>
             <div class="line ">            
            <div class="left">{{$t('个人业绩')}} </div>
            <div class="right">{{ dexc(item.totalInvest)||0 }} <span class="dw">USDT</span> </div>
            </div>
             <div class="line ">            
            <div class="left">{{$t('团队总业绩')}} </div>
            <div class="right">{{ dexc(item.communityPerformance)||0 }} <span class="dw">USDT</span> </div>
            </div>
             <div class="line ">            
            <div class="left">{{$t('小市场业绩')}} </div>
            <div class="right">{{ dexc(item.subCommunityPerformance)||0 }} <span class="dw">USDT</span> </div>
            </div>
         </div>
        </div>
               <div v-if="list.length==0"  class="noData">
                  <img src="../assets/img/isno.png" alt="" >
                  <div class="ttx">{{$t('暂无数据')}}</div>
                </div>
      </div>
     </div>

    <div class="usIcon fadeInUp" >
       <div class="icon">
         <img src="../assets/img/icon1.png" alt="" srcset=""
         @click="to('https://x.com/Baoma_a')"
          class="ico">
       </div>
       <div class="icon">
         <img src="../assets/img/icon2.png" alt="" @click="to('https://t.me/baoma_z')" srcset="" class="ico">
       </div>
       <!-- <div class="icon">
          <img src="../assets/img/gw.png" alt="" srcset="" class="ico">
       </div> -->
      </div>
    
<div class="ubuttom fadeInUp">
  <div class="item " :class="(activeTab==0)?'act':''"  @click="toScroll('section1',0)" > {{$t('首页')}}</div>
   <div class="item" :class="(activeTab==1)?'act':''" @click="toScroll('section2',1)" >{{$t('节点')}}</div>
    <div class="item" :class="(activeTab==2)?'act':''" @click="toScroll('section3',2)" >{{$t('捐赠')}}</div>
     <div class="item" :class="(activeTab==3)?'act':''" @click="toScroll('section4',3)" >{{$t('我的')}}</div>
</div>
   

    


     

  
    
    
      
     

     

     

      
    <div class="buttoms">Copyright © 2026 BM. All rights reserved.</div>

      
    </div>
<!-- 
 <van-popup v-model="showdd" round :close-on-click-overlay="false">
      <div class="popup">       
        <div class="sqtxt">{{$t('m.gg')}}</div>
      <div class="box">
        {{$t('m.ggcont')}}
      
      </div>
      <div class="tt"> {{$t('m.ggtt')}}</div>
      <div class="time"> {{$t('m.ggtime')}}</div>
        <div class="flsz">       
         <div class="btn" @click="showddc()">
          {{$t('m.wzdl')}}
        </div>
        </div>
      </div>
    </van-popup> -->
   

<!-- 授权 -->
 <van-popup v-model="impower" round :close-on-click-overlay="false">
      <div class="popup">       
        <div class="sqtxt">{{$t('要使用您个人账户的功能，请使用钱包授权')}} </div>
        <div class="flsz">       
         <div class="btn" @click="approve">
          {{ sqloading ? $t("授权中") : $t("钱包授权") }}
        </div>
        </div>
      </div>
    </van-popup>
    
<!-- 领取 -->
 <van-popup v-model="lqshow" round :close-on-click-overlay="false">
      <div class="popup">
           <div class="top"> <div class="title">{{$t('确认领取')}}</div>
        <img src="../assets/img/gbs.png" alt="" class="close" v-if="!lqloading" @click="lqshow=false"/>
    </div>
        <div class="sqtxt">{{$t('您有')}}</div>
          <div class="rbox">
            <div class="num">{{lqNum||0}}</div>
            <div class="txt" >BM</div>
           <img src="../assets/img/logo.png" alt=""  srcset="" class="ico">
          </div> 
        <div class="flsz"> 
         <van-button
          :loading="lqloading"
          type="primary"
          @click="scSelect"
          class="btn"
        >
         {{$t('确定领取')}}</van-button
        >
        </div>
      </div>
    </van-popup>

    <!-- 领取余额 -->
 <van-popup v-model="lqshows" round  :close-on-click-overlay="false">
      <div class="popup">   
        <div class="top">
          <div class="title">{{$t('完成钱包确认')}}</div>
            <img src="../assets/img/gbs.png" alt="" class="close" v-if="!lqloading" @click="lqshows=false;loading=false"/>
          </div>    

         <div class="rbox">
            <div class="num">{{xzNum}}</div>
            <div class="txt">USDT</div>
            <img src="../assets/img/usdt.png" alt="" srcset="" class="ico">
          </div> 
          <div class="xbox" >
          <div class="txt">{{$t('授权数量')}}</div>
          <div class="num">{{sqUsdtNum}} BM</div>
        </div>
        <div class="flsz">       
         <van-button
          :loading="lqloading"
          type="primary"
          @click="_toBuy"
          class="btn"
        >
        {{$t('确定')}}</van-button
        >
        </div>
      </div>
    </van-popup>

    <van-popup v-model="shows" round :close-on-click-overlay="false">
      <div class="popup">
        <div class="top"> 
        <div class="title">{{ $t("登录到您的账户") }}</div></div>
        <div class="txt">{{ $t("要使用您个人账户的功能，请点击链接钱包") }}</div>
        <div class="btns" @click="ethConnect">{{ $t("链接钱包") }}</div>     
      </div>
    </van-popup>

 <van-popup v-model="bdshows"  round :close-on-click-overlay="!bdshows">
      <div class="popup">
             <div class="top"> 
        <div class="title">{{ $t("绑定上级") }}</div></div>
        <div class="txt">{{ $t("请输入推荐人钱包地址") }}</div>
        <div>
          <input type="text" class="input" v-model="yqmcode" />
        </div>
        <van-button
          :loading="bdloading"
          type="primary"
          @click="tobding"
          class="btn"
          :loading-text="$t('绑定中')"
        >
          {{ $t("确认绑定") }}</van-button
        >
      </div>
    </van-popup>

    <van-popup v-model="vshow"  :close-on-click-overlay="false">
      <div class="infos"  @click="toPay">
      <video :src="video" class="video" 
          ref="video" 
          autoplay
            x5-playsinline="true"
            preload="auto"  
            webkit-playsinline="true"
            playsinline="true"  
           @ended="isVend"        
            ></video>
            </div>
    </van-popup>
     <Loadings v-if="uploading" />
  </div>
</template>

<script>
import { connectTron ,Sign,getProved,toApprove,getProveds,toApproves,
    getTotalWeight,getTotalData,getNodeCount,getRatio,getMyUsdt,getMyBm,getDayLimit,
  getUser,toBind,toBookOrder,toEnableNode,toWithdrawalStatic,tobmDead,
  toWithdrawalDynamic,toWithdrawalNode,getReferralsInfo} from "@/api/Public";

import Web3 from "web3";
import Loadings from "@/components/loading.vue";
export default {
  name: "Home",
  components: {Loadings},
  data() {
    return {
      totalWeight:0,
      uploading:false,
      wdlp:0,
      bmlp:0,
      tools:0,
      nodeNum:0,
      nodelv:0,
      bmprace:0,
      myusdt:0,
      mybm:0,
      bmDead:0,
      isOpen:false,
      sxshow:false,
      outShow:false,
      langShow:false,
       lang:{},
        langs:[
        {
          icon: require('../assets/img/cny.png'),
          text:"中文",
          show:"CN",
          value:'zh-CN'
        },
        {
          icon: require('../assets/img/en.png'),
          text:"Englist",
          show:"EN",
          value:'en-US'
        },
        {
          icon: require('../assets/img/ka.png'),
          text:"한국어",
          value:'ko-CN'
        },
        {
          icon: require('../assets/img/ja.png'),
          text:"日本語",
          value:'ja-CN'
        },{
          icon: require('../assets/img/tie.png'),
          text:"Vietnamese",
          value:'tie-CN'
        },
        {
          icon: require('../assets/img/tro.png'),
          text:"แบบไทย",
          value:'tro-CN'
        },
      ],
      actions:[{text:100},{text:200},{text:300, disabled: true},{text:400, disabled: true},{text:500, disabled: true}],
      bkdata:'',
      xzNum:'',
      pairs:'',
      value:10,
      datas:'',
      syq: false,
      showdd:true,
      clmenuShows: false,
      bdshows: false,
      show: true,
      shows: false,
      impower: false,
      bsurl:'',
      nodelist: [],
      nodeshow: false,
      ldxnodeshow:false,
      scnodeshow:false,
      more: true,
      userWallet: "",
      yqmcode: "",
      totaljoin: 0,
      dayjoin: 0,
      joinamount: 0,
      myID: "",
      Winner: "",
      Pool: "",
      Time: "",
      buyaddress: "",
      myas: false,
      bang: true,
      acdite: false,
      sqloading: false,
      bdloading: false,
      tbloading: false,
      sdloading:false,
      wshows: false,
      loadings: false,
      Winners: [],
      Cion: "",
      wf: {
        bz: "0",
        sxf: 300,
        sl: "",
        num: 100,
      },
      userInfo:"",
      endTime:0,
      bate:'',
      bates:'',
      showldx:false,
      ldxloading:false,
      showsc:false,
      ldxnum:100,
      mobility:'',
        page:1,
       loading: false,
      finished: false,
      refreshing: false,
      redaio:3,
      type:0,
      current:0,
      lpshow:false,
      lqshow:false,
      lqshows:false,
      lqloading:false,
      lpdata:'',
      base:'',
      feebnb:1,
      vshow:false,
        banner: [ 
        {  "thumb": require('../assets/img/banner.jpg'),"thumb_en": require('../assets/img/banner.jpg')},

      
      ],   
      // video:require('../assets/img/open.mp4'),
      // video:require('../assets/img/vlog.mp4'),  
      video:"",
        codeWallet:"?code=" + this.$store.getters.userWallet,
        lploading:false,
        list:[],
        i:0,
        page:1,
        price:0,
        time:'',
        pricetime:'',
        exshow:false,
        exshows:false,
        exloading:false,
        exmcode:'',
        values:0,
        exnum:'',
        twAmount:'',        
        sqNum:0,
        sqNums:0,
        sqUsdtNum:0,
        sqArcNum:0,
        lqNum:0,
        lqType:0,
        pool:0,
        hoder:0,
        mylp:"",
        energyPool:0,
        energy:{},
        available:0,
         activeTab: 0,
         activeTabs:0,
         isNode:false,
         dayLimit:0
          

    };
  },
  filters: {
      Endtime(e){
    var    end_str = (e).replace(/-/g,"/");//一般得到的时间的格式都是：yyyy-MM-dd hh24:mi:ss，所以我就用了这个做例子，是/的格式，就不用replace了。  
    var end_date =new Date(end_str)-new Date;//将字符串转化为时间  
    return end_date
    },
   
    formatDate(e) {
      if (e == 0) {
        return "";
      } else {
        let date = new Date(e * 1000);
        let Y = date.getFullYear();
        let M = date.getMonth() + 1;
        let D = date.getDate();
        let h = date.getHours();
        let m = date.getMinutes();
        let s = date.getSeconds();
        if (M < 10) {
          M = "0" + M;
        }
        if (D < 10) {
          D = "0" + D;
        }
        if (h < 10) {
          h = "0" + h;
        }
        if (m < 10) {
          m = "0" + m;
        }
        if (s < 10) {
          s = "0" + s;
        }
        return `${Y}-${M}-${D} ${h}:${m}:${s}`;
      }
    },
    yingcang(val) {
      if (val) {
        let a = val.replace(/(\w{7})\w+(\w{4})/, "$1...$2");       
        return a;
      } else {
        return "...";
      }
    },
      time(time){
      if(time){
        var reg = /^(\d{4})-(\d{1,2})-(\d{1,2})\s(\d{1,2})(:(\d{1,2})){2}$/;
        var end = time.match(reg).slice(1,4).join('-');
        return end
      }
    }
  },
   watch: {
    "$store.getters.userWallet": function (val) {
       this.pustadd(val)
    },
    deep: true,
    immediate: true,
  },
  // beforeCreate(){
  //   this.ethConnect()
  // },
  // beforeCreate() {
  //   var i = 0;
  //   var a = setInterval(() => {
  //     if (typeof window.ethereum !== "undefined") {
  //       connectTron().then(
  //         (info) => {
  //           clearInterval(a);
  //           if (info[0]&&info[0].indexOf("0x") == 0) {
  //             if(this.$store.getters.myFil!=info[0]){  
  //               this.userWallet =  info[0]   
  //                this.$store.commit("userWallet", info[0]);   
  //               // this.impower=true
  //               this.cread(info[0])
               
  //               // this.yanzheng(info[0])
  //             }else{
  //               this.$store.commit("userWallet", info[0]); 
  //               this.pustadd(info[0])                  
  //             }
  //             //    
  //             //      
              
  //           } else {
  //             // this.$notify("请使用HECO地址登录游戏");
  //           }
  //         }
  //       );
  //     }
  //     if (i > 5) {
  //       this.$notify("钱包失联了！！");
  //       clearInterval(a);
  //     }
  //     console.log(i);
  //     i++;
  //   }, 1000);
  // },
   
  
  created() { 
      this.yqmcode = this.getQueryString("code");
      this.getbmDead()
      this.InitInfo()  
      this.initWallet()   
      this.initLg()
    // this.showdd=sessionStorage.getItem('ggs')?false:true   
   

 
  },

  computed: {
    dqyy() {
      if (this.$store.getters.language) {
        return this.$store.getters.language;
      } else {
        return "zh-CN";
      }
    }, 
   
  },
  watch: {
    "$store.getters.userWallet": function (val) {
      this.cread(val);
    },
    deep: true,
    immediate: true,
  },
  methods:{
    initWallet(){    
       this.userWallet= this.$store.getters.userWallet
      if(this.userWallet){
        this.cread(this.userWallet)
         this.initLang()
        //  this.upData()
        //  this.upDatas()
      }else{
        this.shows=true
      }      
    },
     dexc(val){
 if(val){
  let  ethereum = window.ethereum
 let web3s = new Web3(ethereum);
  let amount=  web3s.utils.fromWei(val +'', 'ether'); 
  // let num =val/Math.pow(10,18)
  return val?  Math.round(amount*1000000)/1000000:'0'
 }else{
  return 0
 }
 },
  Login() {
      if(this.userWallet){
        this.outShow=!this.outShow
      }else{
      this.ethConnect()
      }
    },
    langOpen(){
      this.langShow=!this.langShow
    },
    toOut(){      
          this.userWallet=""
          this.$store.commit("userWallet", ""); 
          this.outShow=false 
          this.shows=true     
    },
    initLg(){
this.langs.map(el=>{
      if(el.value==this.$store.getters.language){
        this.lang=el
      }
    })
    },
    initLang(){
      let baseUrl=((window.location.href).split("/#/"))[0]
    if(baseUrl.indexOf('?')){
        baseUrl= ((baseUrl).split("/?"))[0]
        this.codeWallet= baseUrl+"?code=" +this.userWallet   
    }else{
       this.codeWallet= baseUrl+"?code=" + this.userWallet
    }
            
    },
    onSelectLang(item) {
      this.lang=item
      let val=item.value
      this.$i18n.locale = val;
      this.$store.commit("language", val);
      this.langShow=false
      console.log(item);
    },
     visibilityChanged0(isVisible, entry) {
      // console.log('show1',isVisible,this.activeTab,this.activeTabs);
      if (isVisible) {
        this.activeTab = 0;
      }
    },
    visibilityChanged1(isVisible, entry) {
    //  console.log('show2',isVisible,this.activeTab,this.activeTabs);
     if (isVisible) {
        this.activeTab = 1;         
      } else{
        
        setTimeout(() => {
          // this.activeTabs=this.activeTab==this.activeTabs?1:0
        }, 100);
        
      }
    },
     visibilityChanged2(isVisible, entry) {
      // console.log('show3',isVisible,this.activeTab,this.activeTabs);
      if (isVisible) {
        this.activeTab = 2;
      } else{
        //  this.activeTabs=this.activeTab==2?2:0
      }
    },
     visibilityChanged3(isVisible, entry) {
      // console.log('show4',isVisible,this.activeTab,this.activeTabs);
      if (isVisible) {
        this.activeTab = 3;
      } else{
        // this.activeTabs=this.activeTab==3?3:0
      }
    },
    toScroll(e,i){
      this.activeTab=i
      this.activeTabs=i
       this.$nextTick(() => {
        document.getElementById(e).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
          alignToTop:'true'
        })
      })
    },
  InitInfo(){
    getTotalData().then(res=>{
      this.tools=res.data2
    })
    getNodeCount().then(res=>{
      this.nodeNum=res||0
      this.nodelv=((1-this.nodeNum/300)*100).toFixed(2)
    })
    getRatio().then(res=>{
      this.bmprace=res
    }) 
    getTotalWeight().then(res=>{
      this.totalWeight=res
    })   
  },
  getUsdt(){
    getMyUsdt(this.userWallet).then(res=>{
      console.log(res,'usdt');
      this.myusdt=res
    })
  },
 getBm(){
    getMyBm(this.userWallet).then(res=>{
      this.mybm=res
    })
  },

async toBuyNode(){
  if(this.myusdt-500<0){
    return
  }
  this.loading=true
    this.sqNums=await getProveds(this.userWallet).then(res=>{ return res})
   this.sqArcNum=500
   if(this.sqArcNum-this.sqNums>0){
     toApproves(this.userWallet,this.sqArcNum).then(res=>{
            // console.log(res);
            if(res){   
              this.sqNum=this.sqArcNum 
               setTimeout(() => {
                this._toBuyNode()
              },3000); 
            }else{
              this.lqloading=false
              this.loading=false
            }
        })
   }else{
    this._toBuyNode()
   }
},
_toBuyNode(){
toEnableNode(this.userWallet).then(res=>{
      this.loading=false
    if(res){
    this.$notify({
                message:this.$i18n.t("认购成功") ,
                type: "success",
    });
    this.upUser()
    }else{
 this.$notify(this.$i18n.t("认购失败"))
      
    }
  })
},
async toBuy(){
   if(this.xzNum-100<0){
     this.$notify(this.$i18n.t("最小捐赠数量100"))
    return
  } 
  let max= this.dayLimit-this.userInfo.userDayBuy
    if(this.xzNum-max>0){
     this.$notify(this.$i18n.t("已超当日投入额"))
    return
  } 
  this.loading=true
    this.sqNum=await getProved(this.userWallet).then(res=>{ return res})
     
   this.sqUsdtNum=((this.xzNum/this.bmprace+10).toFixed(0))
   this.lqshows=true
},

_toBuy(){
  if(this.sqUsdtNum-this.mybm>10){
     this.$notify(this.$i18n.t("您的BM余额不足"))
    return
  }
    this.lqloading=true
   if(this.sqUsdtNum-this.sqNum>0){
     toApprove(this.userWallet,this.sqUsdtNum).then(res=>{
            // console.log(res);
            if(res){   
              setTimeout(async () => {
                   this.sqNum=await getProved(this.userWallet).then(res=>{ return res})
                   if( this.sqNum=this.sqUsdtNum ){
                          this._toBuy()
                   }               
              }, 3000);              
            }else{
              this.lqloading=false
              this.loading=false
            }
        })
   }else{

     toBookOrder(this.userWallet,this.xzNum).then(res=>{
            console.log(res);
            this.lqloading=false
            if(res){
              this.lqshows=false
              this.loading=false
              this.$notify({
                message: this.$i18n.t("捐赠成功"),
                type: "success",
              });
              this.upUser()
            }else{
              this.loading=false
              this.$notify({
                message: this.$i18n.t("捐赠失败"),
                type: "danger",
              });
            }
          })
   }
},

  toshow(e,j){
      this.$set(this.list[e],'show',!j)
    },

getList(){
  // this.list=[{show:false},{show:false}]
  // return
  let waw=this.userWallet
  getReferralsInfo(waw).then(res=>{
    console.log(res,'-----');
    if(res){
       this.list=[]
          res.map(el=>{
            let obj=Object.assign({},el)
            obj.show=false
            this.list.push(obj)
          })
    }

  })
},

getbmDead(){
  tobmDead().then(res=>{
    this.bmDead=(res*1).toFixed(0)
  })
},










































    showddc(){
      this.showdd=false
      sessionStorage.setItem('ggs','1')
    },
    togetAvailableEnergy(){  
      getAvailableEnergy(this.userWallet).then(res=>{
        console.log(res);
        this.available=res     
      })  
    },
    toGetEnergy(){
      getEnergy(this.userWallet).then(res=>{
        console.log(res,'getEnergy');
        this.energy=Object.assign({},res)
        this.energy.totalEnergy=(res.totalEnergy/10**18).toFixed(4)
        this.energy.withdrawalEnergy=(res.withdrawalEnergy/10**18).toFixed(4)
      })
    },
    toEnergyPool(){
      getEnergyPool().then(res=>{
        console.log(res);
        this.energyPool=(res*1).toFixed(4)
      })
    },
    toWithdrawEnergy(){
        getWithdrawEnergy(this.userWallet).then(res=>{
        console.log(res,'getWithdrawEnergy');
        if(res){
          this.lqshow=false
          this.$notify({
                message:this.$i18n.t("领取sg") ,
                type: "success",
              });
        }
      })
    },
    togetHouder(){
       getHoder().then(res=>{this.hoder = res
        })

        //  fetch('https://api.dryespah.com/v1api/v3/tokens/0x68e500bee8a7233b65c2bea0ae8eb4ac9d3310b3-bsc',{
        //   method:'get',
        //   headers:{"X-Auth": "c2a710a3a5de4247ff66455fe6c8b3b11725759399016106720"}
        //  }).then(response => response.json())         
        //   .then(data =>
        //   {let d=JSON.parse(data.data)
        //   console.log(d.token.holders);
        //   this.hoder=d.token.holders
        //   }
        //   )
    },
    togetMyDeedPool(){
      getMyDeedPool().then(res=>{
        this.pool=(res*1).toFixed(4)      })
    },
    toLqShow(num,t){
      // this.$notify(this.$i18n.t("m.zwkf"))
      //     return     
      this.lqNum=num
      this.lqType=t
      this.lqshow=true
    },
      handlePageLoad() {
      // 页面刷新后的逻辑
      console.log('页面已经刷新');
      //  this.vshow=true
    },
    isVend(){     
      this.vshow=false    
       if(this.userInfo.referrer=="0x0000000000000000000000000000000000000000"){
            this.bdshows = true;
      }   
      sessionStorage.setItem('video',this.vshow)
    },
    onSelect(e){
      this.xzNum=e.text
      this.sxshow=false
    },
    async toJoin(){
      if(this.xzNum>0){ 
        this.loading=true
        this.sqUsdtNum=((this.xzNum)*0.3/2).toFixed(4)
       await this.toGetsq()
        getUtoArc(this.sqUsdtNum).then(res=>{
          console.log(res);
          this.sqArcNum =(res*1).toFixed(4)
          this.lqshows=true         
        })
      }
    },
    async toGetsq(){
      this.sqNum=await getProved(this.userWallet).then(res=>{ return res})
      this.sqNums=await getProveds(this.userWallet).then(res=>{ return res})
      console.log(this.sqNum,this.sqNums);
    },
   async scSelects(){
       await this.toGetsq()
       if(this.xzNum<=0){return}
       if(!this.userWallet){return}
      this.lqloading=true
      console.log(this.sqUsdtNum -this.sqNum>0);
      if(this.sqUsdtNum-this.sqNum>0){
        toApprove(this.userWallet,this.sqUsdtNum).then(res=>{
            // console.log(res);
            if(res){   
              this.sqNum=this.sqUsdtNum 
              this.scSelects()
            }else{
              this.lqloading=false
            }
        })
      }else if(this.sqArcNum -this.sqNums>0){
        let num=Math.ceil(this.sqArcNum)
        toApproves(this.userWallet,num).then(res=>{
            // console.log(res);
            if(res){    
             this.sqNums= this.sqArcNum 
              this.scSelects() 
            }else{
                this.lqloading=false
              }
        })
      }else {
        toBookOrder(this.userWallet,this.xzNum).then(res=>{
            console.log(res);
            this.lqloading=false
            if(res){
              this.lqshows=false
              this.loading=false
              this.$notify({
                message: this.$i18n.t("认购成功"),
                type: "success",
              });
            }else{
              this.$notify({
                message: this.$i18n.t("认购失败"),
                type: "danger",
              });
            }
          })
      }
  },
    toexchange(){
      this.exnum=''
      this.exshow=true
    },
       async upData(){
         this.$get({
        url: "/bm/lp/getBmLp",
         data:{ 
           trxAddress: this.userWallet
         },
        callback: (res) => {
          this.$nextTick(function () {
            if (res.data) {
                 this.bmlp=res.data
              }
          })
        }
       })
       },
        async upDatas(){
             this.$get({
        url: "/bm/lp/getWdLp",
         data:{ 
           trxAddress: this.userWallet
         },
        callback: (res) => {
          this.$nextTick(function () {
            if (res.data) {
                 this.wdlp=res.data
              }
          })
        }
       })
       },
    jstwAmount(){
      setTimeout(() => {      
      this.twAmount=this.userInfo.usdtAmount-this.twAmount>0?this.twAmount:this.userInfo.usdtAmount     
      }, 100);
    },
    toexchanges(){
      if(this.exnum>0){
             this.$post({
        url: "wms-wallet/exchange",
         data:{
         trxAddress:this.$store.getters.userWallet,
         uid:this.$store.getters.myID,
         amountT:this.exnum,
         amountU:(this.exnum*this.price).toFixed(4),
         rate:this.price,
         type:1
         },
        callback: (res) => {
          this.$nextTick(function () {
            if (res.data) {
              this.exshow=false
              this.upUser()
                  this.$notify({
                message: this.$i18n.t("m.sdsuc"),
                type: "success",
              });
              }else{
                this.$notify(this.$i18n.t("m.sderr"))
              }
          })
        }
       })
      }
    },
    toexcheng(){
      this.exmcode=''
      this.exshows=true
    },
 

  
handleFiexdToolItem(e){
    // this.$notify(this.$i18n.t("m.wxtszwkf"))
    // return
  this.$router.push({path:e})
},
 onChange(index) {
      this.current = index;
    },
toimpower(){
  this.$notify(this.$i18n.t("m.wxtszwkf"))
  //  if(this.$store.getters.userWallet){
  //     this.impower=true
  //     }else{
  //       this.shows=true
  //     }
},
approve(){
   console.log('1',this.userWallet);  
  if(this.userWallet){
    this.sqloading=true
     Sign(this.userWallet).then(rs=>{
      if(rs){                
              this.sqloading=false   
               this.impower=false  
                this.$store.commit("userWallet", this.userWallet);   
              this.$store.commit("myFil", this.userWallet);     
              console.log('1',this.userWallet);        
              this.cread(this.userWallet)    
       }
      })
  }
},


      lqselects(e){
          this.$notify(this.$i18n.t("m.zwkf"))
          return     
    },

  async scSelect(){
    // if(this.lqNum<=0){return}
    this.lqloading=true
    if(this.lqType==1){
      toWithdrawalStatic(this.userWallet).then(res=>{
        this.lqloading=false
        if(res){
          this.upUser()
          this.lqshow=false
          this.$notify({
                message:this.$i18n.t("领取成功") ,
                type: "success",
              });
        }else{
          this.$notify(this.$i18n.t("领取失败"))
        }
      })      
    }
    if(this.lqType==2){
      toWithdrawalDynamic(this.userWallet).then(res=>{
        this.lqloading=false
        if(res){
          this.upUser()
          this.lqshow=false
           this.$notify({
                message: this.$i18n.t("领取成功") ,
                type: "success",
              });
        }else{
          this.$notify(this.$i18n.t("领取失败"))
        }
      })
    }  
    if(this.lqType==3){
      toWithdrawalNode(this.userWallet).then(res=>{
        this.lqloading=false
        if(res){
          this.upUser()
          this.lqshow=false
           this.$notify({
                message: this.$i18n.t("领取成功") ,
                type: "success",
              });
        }else{
          this.$notify(this.$i18n.t("领取失败"))
        }
      })
    }  
    },


    to(url) {
       window.open(url)
    },
   
  

    getLp(){
    
    },
    cread(val) {
      if(val){
      this.userWallet = val;  
      this.initLang()
      this.uploading=true
      this.getList() 
      this.upUser()
      }
    },
    upUser(){  
       getUser(this.userWallet).then(res=>{   
          console.log(res);            
          this.userInfo=Object.assign({},res)
          this.userInfo.totalInvest=(res.totalInvest/10**18).toFixed(4)
          this.userInfo.communityPerformance=(res.communityPerformance/10**18).toFixed(4)
           this.userInfo.subCommunityPerformance=(res.subCommunityPerformance/10**18).toFixed(4)
             this.userInfo.tReward=(res.tReward/10**18).toFixed(4)
             this.userInfo.sReward=(res.sReward/10**18).toFixed(4)
             this.userInfo.lReward=(res.lReward/10**18).toFixed(4)
             this.userInfo.nReward=(res.nReward/10**18).toFixed(4) 
              this.userInfo.userDayBuy=(res.userDayBuy/10**18).toFixed(4)   
             this.userInfo.weight=(res.weight/10**18).toFixed(4)
             this.userInfo.maxReward=(res.maxReward/10**18).toFixed(4)  
             this.userInfo.rewardlv= this.userInfo.maxReward>0? ((this.userInfo.tReward/this.userInfo.maxReward)*100).toFixed(2):0
          // if(this.vshow){return}
          this.uploading=false
          if(res.referrer=="0x0000000000000000000000000000000000000000"){
            this.bdshows = true;
          }
        })  
           this.getBm()
          this.getUsdt()  
          this.getdayLimit()
          //  this.upData()
        //  this.upDatas()
    },
 
    getdayLimit(){
      getDayLimit().then(res=>{
        this.dayLimit=res
      })
    },
    

    zwkf(){
         this.$notify(this.$i18n.t("m.zwkf"))
    },
 

  toPay(){
    var video = this.$refs.video;
  video.play();
  },
   
    toshowasd() {
      if (this.$store.getters.theame) {
        if (this.$store.getters.theame == 1) {
          this.acdite = true;
        } else {
          this.acdite = false;
        }
      } else {
        this.acdite = false;
      }
      console.log(this.acdite);
      window.document.documentElement.setAttribute(
        "data-theme",
        this.acdite ? "dark" : "light"
      );
    },
    toggleTheme() {
      this.acdite = !this.acdite;
      window.document.documentElement.setAttribute(
        "data-theme",
        this.acdite ? "dark" : "light"
      );
      this.acdite
        ? this.$store.commit("theame", "1")
        : this.$store.commit("theame", "0");
    },
    tobding() {
      if (this.yqmcode) {
        if (this.bdloading) {
          this.$toast(this.$i18n.t("绑定中"));
          return;
        } else {
            this.bangding(this.yqmcode);
        
        
        }
      } else {
        this.$toast(this.$i18n.t("请输入推荐人钱包地址"));
      }
    },
 
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    onCopy() {
      this.$toast(this.$i18n.t("复制成功"));
    },
    onError() {
      this.$toast(this.$i18n.t("复制失败"));
    },
    //总投资
    async joinAmount() {
      this.joinamount = await window.ContractEth.methods.joinAmount().call();
    },
    
    ethConnect() {
      connectTron().then((info) => {
        if (info[0]&&info[0].indexOf("0x") == 0) {          
           this.shows=false 
        
           if(this.$store.getters.myFil!=info[0]){
            this.impower=true
            this.userWallet=info[0]
            console.log('lj--',this.userWallet);  
            }else{ 
               this.$store.commit("userWallet", info[0]);   
               this.cread(info[0])             
           }        
         
        } else {
          // this.$toast(this.$i18n.t("m.qsydzdl"));
        }
      });
    },
    pustadd(info){     
      this.$store.commit("userWallet", info); 
    },


    async bangding(code) {
       
        if (code) {
          if(code==this.userWallet){return}
          this.bdloading=true
          toBind(this.userWallet,code).then(res=>{
            this.bdloading = false;
            if(res){
              this.$toast(this.$i18n.t("绑定成功"));
              this.bdshows = false;
            }else{
              this.$toast(this.$i18n.t("绑定失败"));
            }
            console.log(res);
             
          })      
        } else {
          this.bdloading = false;
        }      
    },
  
    igbs() {
      this.show = false;
    },
    tosee() {
      this.more = !this.more;
    },
   
  
    goto(val,e) {   
       clearInterval(this.time);   
       if(e){
        
       this.$router.push({ path: val,query:{ac:e} }); 
       }else{
      this.$router.push({ path: val });
       }

    },
    async toPage(val) {    
     if(this.$store.getters.userWallet){
       this.$router.push({ path: val });
      }else{
        this.shows=true
      }
    },
  },
  

};
</script>

<style lang="scss" scoped>
@import "../../src/assets/scss/_handle.scss";

$t-mf: "PingFang";
$t-f: "DINAlternate-Bold";

.home {
  background:  #000000 url("../assets/img/pbg.png")  no-repeat;
  // background: #161628;
  background-size:contain;
  background-position: center bottom;
  overflow-x: hidden;
  width: 750px;
  margin: 0 auto;

.HeaderTop{

position: fixed;
    top: 0;
    z-index: 99;
    
background: #000000bf;
      // background: url("../assets/img/tbg.png")  no-repeat;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 15px;
    width: calc(100%);
    max-width: 750px;
    margin: 0 auto;
    color: #fff;
    box-sizing: border-box;
    border-bottom: 1px solid #333333;
    .logo {
      display: flex;
      align-items: center;    
      .slogo{
display: flex;
align-items: center;
      .slo{
// background: linear-gradient(
// 128deg
// ,#ffdf2d,#00e2be);
// background: linear-gradient(
// 128deg
// ,#e7efcd,#00e2be);
// box-shadow: 0px 4px 16px 4px #00e2be;
// border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
      }

.ttt{
font-size: 32px;
font-family:$t-f;
font-weight: 600;
color: #FFFFFF;
margin-left: 10px;
}
        .img2{
          width: auto;
          height: 68px;
          // margin-left: -50px;
          // border-radius: 6px;
        }
      }
    }
     .title{
      color: #fff;
      font-size: 36px;
      font-family: $t-mf;
    }
    .navbtn {
      display: flex;
      justify-content: center;
      align-items: center;
     min-width: 170px;
     padding: 0 40px;
height: 60px;
border-radius: 100px;
margin-right: 16px;
 border: 1px solid #35dcf7;
// background: linear-gradient(188.1deg, rgb(175, 57, 239) 18.52%, rgb(139, 61, 206) 71.67%);
// background: url('../assets/img/bm/b1.png') no-repeat;
background-size: 100% 100%;
font-family: $t-mf;

// background: linear-gradient(
// 128deg
// ,#ffdf2d,#00e2be);
// box-shadow: 0px 4px 16px 4px rgba(62,1,162,1);
// border-radius: 30px;
font-size: 28px;
font-weight: 600;
color: #FFFFFF;
  
    }
      .icosn {
        margin-right: 15px;
       width: 42px;
height: 42px;
// border-radius: 16px;
display: flex;
align-items: center;
justify-content: center;
        .img{
          width: 42px;
        }
      }
      .flexright{
        display: flex;
        align-items: center;
        position: relative;
        .loginOut{
  width: 120px;
    background-color: #000;
    color: #fff;
    z-index: 99;
    position: absolute;
    right: 106px;
    top:103px;
    border-radius: 32px;
    backdrop-filter: blur(40px);
    background-color: #40404080;
    padding: 40px 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .item{
      display: flex;
      align-items: center;
      justify-content: center;
    }
      
}
        
.i18npor{
  min-width: 180px;
    background-color: #000;
    color: #fff;
    z-index: 99;
    position: absolute;
    right: 8px;
    top:103px;
    border-radius: 32px;
    backdrop-filter: blur(40px);
    background-color: #40404080;
    padding: 40px 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .item{
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      .img{
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        margin-right: 12px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .txt{
        color: #ffffff;
        font-size: 30px;
        flex: 1;
        text-align: left;
      }
      .icon{
        width: 44px;
        height: 44px;
      }
    }
    .item:last-child{
      margin-bottom: 0;
    }
}
            .lang {
        font-size: 22px;
        font-family: $t-mf;
        font-weight: 600;
       color: #ffffff;
      //  margin-right: 32px;
        // line-height: 42px;
        margin-left: 20px;
          .limg{
        height: 40px;
        width: 40px;
        border-radius: 100%;
      }
      .ttl{
        font-size: 24px;
font-family: $t-f;
font-weight: 600;
color: #FFFFFF;
line-height: 34px;
margin-left: 10px;
margin-right: 10px;
      }
          .bbox{
      display: flex;
      align-items: center;      
    justify-content: center;
    }
          .dwimg{
        width: 32px;
        margin-left: 10px;
      }
      }
      }

}

  .mtop {
    margin: 140px 10px 0;
    padding: 10px 30px ;
    color: #fff;
   
    border: 1px solid #381b7c;
    .zctime{
      color: #fff;
      text-align: left;
      margin: 20px 0px;
      display: flex;
    align-items: center;
    justify-content: space-between;
    }
    .price {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .txt {
        font-size: 26px;
        color: #ffffff;
        text-align: left;
        margin: 20px 0;
      }
      .num {
        font-size: 36px;
        color: #ffffff;
        margin-right: 10px;

        .dw{
          font-size: 32px;
          color: #ffffff;
          margin-right: 5px;
        }
      }
      .right{ 
        display: flex;
      align-items: flex-end;
      flex-direction: column;
      justify-content: space-between;
        .txt{
          font-size: 26px;
        color: #8d9399;
        text-align: left;
        margin: 20px 0;
        }
        .nums{ font-size: 46px;
        font-family: $t-f;
        font-weight: bold;
        background: linear-gradient(234deg,#e4005e, #b4184c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;}
      }
    }
    .address {
      margin: 28px;
      display: flex;
      align-items: center;
      font-size: 30px;
      font-family: $t-mf;
      font-weight: bold;
      color: #ffffff;
      line-height: 28px;
      .fuzhi {
        background: transparent;
        border: none;
      }
      .icon {
        width: 26px;
        height: 26px;
        margin-right: 16px;
      }
    }
    .close {
      position: absolute;
      right: 22px;
      top: 28px;
      img {
        height: 32px;
        width: 32px;
      }
    }
  }
  .ubuttom{
    display: flex;
    align-items: center;
    padding: 30px;
    justify-content: space-between;
    width: 100%;   
    box-sizing: border-box;
    max-width: 750px; 
    background: #000000;
    position: fixed;
    bottom:0;
    transform: translateX(-50%);
    left: 50% ;
    z-index: 999;
    .item{
      width: 25%;
      font-size: 28px;
      color: #ffffff;
      padding-bottom: 16px;
    }
    .act{
      color:#00d5ff;
         position: relative;
    }
    .act::after{
      content: "";
      position: absolute;
      height: 4px;
      width: 20px;
      border-radius: 40px;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(200deg, #12c2fc 0%, #3ae2f8 31%, #14a5d0 49%, #441dda 79%, #0b1042 100%);
    }
  }

  .sylist{
    display: flex;
    align-items: center;
    padding: 30px;
    justify-content: space-between;
    .boxl{
      background: linear-gradient(-18deg, #ffdf2d, #00e2be);;
      // border-radius: 18px;
      height: 140px;
      width: 45%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      position: relative;  
    }
    .boxr{
      background:rgba(38, 38, 38, 0.48);//#262626 ;
      // border-radius: 18px;
      height: 140px;
      width: 45%; display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center; 
      position: relative;   
    }
    .stl{
      margin: 10px 30px;
      color: #ffffff;
      font-size: 22px;
    }
    .snum{
        margin: 10px 30px;
      color: #ffffff;
      font-size: 26px;
    }
    .flximg{
      position: absolute;
      right: 20px;
      width: 130px;
    }
  }
  
  .mdex{
    font-size: 24px;
    color: #fff;
    background: rgba(0 0 0 / 24%);
    margin: 0 0 20px;
    padding: 20px;
    border-top:1px solid  #6d6d6d
  }
  .my-swipe {
    width: 694px;
    min-height: 360px;
    margin: 10px auto 0;
    .imgs {
      width: 100%;
      height: 100%;
      // border-radius: 20px;
    }
  }
  
  .band {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    height: 199px;
    width: 199px;
    margin: 10px auto;
    animation: rotate 10s linear 0.1s infinite;
    img {
      height: 38px;
      width: 246px;
      margin: 64px auto;
    }
  }

  @keyframes rotate {
    0% {
      opacity: 1;
      transform: rotate(0deg);
    }

    100% {
      opacity: 1;
      transform: rotate(360deg);
    }
  }
  .dark.band {
    // background-image: url("../assets/img/badns.png");
  }
  .content {
  //  background: url("../assets/img/bm/b6.png") ;
    background-size: 100% auto;
    background-position: bottom ;
    // margin-top: 160px;
    .shome{
    background: url("../assets/img/pbg.jpg") ;
    background-size: 100% auto;
    background-position: bottom ;
    // min-height:100vh;
    .cardBox{
      height: 100%;
      background: #00000070;
      backdrop-filter:blur(1px);
      min-height:90vh;
    .logo{
      padding-top: 180px;
      .img{
        width: 288px;
        height:288px;
        background: #000000;
        border-radius: 100%;
      }
    }
    .stitle{
      font-size:46px;
      color:#fff;
      font-weight: 600;
      line-height: 54px;
      margin:52px auto 26px;
    }
    .tips{
      font-size:28px;
      color:#ffffff;
      font-weight: 400;
      width: 95%;
      margin:0 auto;
    }
    .slist{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 38px;
      .item{
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
         background: rgb(153 145 145 / 71%);
      backdrop-filter:blur(1px);
        background-color: rgb(0 0 0 / 21%);
    box-shadow: 0px -1px 0rem 2px #ffffff, 0 0 0.21333rem rgba(255, 255, 255, 0.4117647059), inset 0 0 0.21333rem rgba(255, 255, 255, 0);
       background-image: linear-gradient(rgb(255 253 253 / 44%) 2px, rgb(237 237 237 / 51%) 5%, rgba(0, 0, 0, 0));
        margin:42px 22px;
      padding:24px 0;
      border-radius: 40px;
      height:268px;
      width: 33%;
      .laber{
        font-size: 28px;
        color: #ffffff;
        margin-bottom: 12px;
        width: 120px;
        white-space: nowrap;
        overflow: hidden;
      }
      .num{
        font-size: 32px;
 color: #ffffff;
  margin-bottom: 12px;
      }
      .img{
        width: 48px;
        height: 48px;
      }
      }
      .item:hover,.cent{
        padding:32px;
         height:288px;
        .img{
          width: 88px;
          height:88px;
        }
      }
    }
    }
    }
    .actives {
      // padding: 56px 0;
    background: #00000070;
    // border-radius: 20px;
    // background-size: cover;
        // border-radius: 30px;
    width: calc( 100%);
    margin: 0 auto;
    .my-swipe1 {
    width: calc( 100% - 20px);
    height: 100%;
    margin: 0 auto;
    // padding: 10px; 
     .imgss {
      width: calc(100%);
      height: 400px;
        //  border:2px solid #3bf7ff;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 1px 1px rgb(0 0 0 / 12%), 0 2px 2px rgb(0 0 0 / 12%), 0 4px 4px rgb(0 0 0 / 12%), 0 8px 8px rgb(0 0 0 / 12%), 0 16px 16px rgb(0 0 0 / 12%);
    }
    }
    .notific{
      background: #2A2A2A;
      display: flex;
      align-items: center;
      width: 100%;
      padding: 14px;
      margin-top: -16px;
    z-index: 10;
    position: relative;
      .ico{
        width: 46px;
        height: 46px;
      }
      .txt{
        font-size: 26px;
        color: #ffffff;
        margin-left: 16px;
        margin-bottom: 5px;
      }
      .right{
        flex: 1;
        width: 100%;
        font-size: 28px !important;
      }
    }
    .simg{
      width: 256px;
      height: 256px;
      margin: 20px auto 0;
      // border-radius: 10px;
    }
      .title {
        font-size: 30px;
        font-family: $t-mf;
        font-weight: 600;
        @include font_color("font_color2");
        line-height: 54px;
        padding:30px 32px 12px;
      }
      .info {
        width: 600px;
        min-height: 52px;
        font-size: 24px;
        font-weight: 400;
        @include font_color("font_color2");
        line-height: 52px;
        margin: 12px auto 33px;
        text-align: left;
      }
     
      .btngrop{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .btn {
        width: calc(100% - 40px);
        height: 80px;
        background: #b4184c;
        box-shadow: 0px 4px 16px 4px rgba(62,1,162,1);
        // border-radius: 40px;
        font-size: 32px;
        font-family: $t-mf;
        margin:34px 20px;
        font-weight: 600;
        @include font_color("font_color3");
        line-height: 80px;
        text-align: center;        
border: 2px solid rgba(115, 40, 236, 0.5);
font-weight: bold;
      }
      .act{
        background: #290E54;
box-shadow: 0px 4px 16px 4px rgba(62,1,162,1);
// border-radius: 40px;
border: 2px solid rgba(115, 40, 236, 0.5);
      }
    }
   
    .m100{
      padding-top: 100px;
      height: 1px;
      transition: all 0.3s ;
      transition-delay: 0.5s;
    }
    .card {
      // width: 694px;
       background:#00000070 url("../assets/img/sbg.png") no-repeat ;      
      // background: #00000070;
      // background: linear-gradient(200deg, #12c2fc 0%, #3ae2f8 31%, #14a5d0 49%, #441dda 79%, #0b1042 100%);
         background-size: 230px auto;
    background-position: right bottom;
          align-items: center;
          border: 1px solid rgb(53, 53, 53);
      border-radius: 60px;
      // min-height: 300px;
      padding: 30px 40px;
      margin: 20px 30px 20px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .titles{
        font-size: 28px;
          font-weight: 600;
          color: #ffffff;
          padding-bottom: 30px;
          width: 100%;
          border-bottom: 1px solid rgb(53, 53, 53);
      }
      .t24{
        font-size: 32px;
      }
      .list {    
        width: 100%;  
        margin: 20px 0; 
        .items {

          .tops{
 display: flex;
        justify-content: space-between;
      align-items: center;
      background: linear-gradient(135.46deg,rgba(6,6,6,.5) 24.8%,rgba(32,32,32,.5) 57.07%);
      border: 1px solid #35dcf7;
      border-radius: 40px;
      margin: 18px 0;
      padding: 30px 40px;
      font-weight: 400;
      font-size: 28px;
      font-family: $t-f;
          
      
          .sord {
            text-align: left;
          font-size: 24px;
          font-family: $t-mf;
          font-weight: 400;
          color: #35dcf7;
          line-height: 32px;
          }
          .address {
              height: 32px;
              font-size: 28px;
              font-family: $t-f;
              font-weight: bold;
              line-height: 32px;
              margin: 0 13px;
              color: #ffffff;
              flex: 1;
              text-align: left;
           
          }
          .num {
            font-size: 28px;
       
        background: linear-gradient(90deg, #6cd0cb 0%, #71c5ed 51%, #0695a3 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        .dw{
          font-size: 18px;
          color: #f8f8f8;
          font-weight: 400;
        }
          }
        }
        }
        .bottoms{
           display: flex;
        justify-content: space-between;
        align-items: center;
        // width: 100%;
      flex-direction: column;
      background: #101010;
    border-radius: 40px;
    padding: 20px;
       .line{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px;
        width: 100%;
        flex: 1;
        .left {
        text-align: left;
          font-size: 24px;
          font-family: $t-mf;
          font-weight: 400;
          color: #f8f8f8;
          line-height: 32px;
      }
      .right {
        font-size: 28px;
        font-family: $t-f;
        color: #35dcf7;
        // background: linear-gradient(180deg, #00d5ff, #ffffff);
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
        .dw{
          font-size: 22px;
          color: #12c2fc;
        }            
      }
      }
        }
      }
       .noData{
		width: 100%;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
    min-height: 30vh;
		img{
			width: 200px;
			margin: 50px auto 20px;
		}
     .ttx{
      font-size:32px;
      color: #ffffff !important;
  font-family: $t-f;
   font-weight: bold;
    }
	}
      .banner{
            width: 100%;
    // border: 1px solid rgb(53, 53, 53);
 border-radius: 40px;
 padding:0;
   height: 300px;
    margin: 24px auto 0;
    position: relative;
    overflow: hidden;
        .img{
          width: 100%;
          height: 100%;
             border-radius: 40px;
              padding:0;
                  position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
        }
      }
  
      .box{
        width: 100%;
        position: relative;
        .balance{
             font-size: 24px;
           color: #ffffff;
           margin-top: 40px;
           text-align: left;
        }
        .tips{
           font-size: 24px;
           color: #ffffff;
           margin-top: 40px;
          }
          .line{
            width: 100%;
            height: 1px ;
            background: #353535;
            margin-top: 40px;
          }
          .m10{
            margin: 20px 0;
          }
          .bord{
                border: 1px solid #35dcf7;
                padding: 12px;
                border-radius: 16px;
          }
          .m10{
            margin-top: 36px;
          }
           .node {
            position: absolute;
            top: 12px;
            right: 0;
            width: 280px;
            height: 280px;
          }
           .ctop {
            display: flex;
            flex-direction: column;
            margin-bottom: 32px;
            padding-top:32px;
            border-bottom: 1px solid #d9d9d91a;
            padding-bottom: 40px;
            .name {
              font-weight: bold;
              font-size: 42px;
              line-height: 32px;
              margin-bottom: 48px;
              color: #ffffff;
              text-align: left;
            }
            .ccr{
              color: #ed1414;
              font-size: 46px;
            }
            .txt {
              font-weight: 400;
              font-size: 24px;
              line-height: 24px;
              margin-bottom: 24px;
              color: #ffffff;
               text-align: left;
            }
            .price {
              display: flex;
              align-items: center;
              .num {
                font-weight: 900;
                font-size: 56px;
                margin-bottom: 24px;
              }
              .dw {
                font-size: 28px;
              }
            }
            .cor1 {
              background: linear-gradient(
                90deg,
                #d0a66c 0%,
                #f1f5ba 51%,
                #c9a159 100%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            .cor2 {
               background: linear-gradient(90deg, #6cd0cb 0%, #71c5ed 51%, #0695a3 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
            }
            .cor3 {
              color: #6793fa;
            }
            .cor4{
              color: #dbc186;
            }
            .snum {
              font-weight: 400;
              font-size: 24px;
              line-height: 24px;
              color: #ffffff;
               text-align: left;
            }
          }
          .rgcont{
            display: flex;
          align-items: center;
          flex-direction: column;
          .logos{
            .img{width:188px;height:188px;}
            margin: 24px auto;
          }
          .nums{
             display: flex;
          align-items: flex-end;
            text-align: center;
            font-size: 68px;
            color: #00d5ff;
            margin:0px auto 32px;
            text-shadow: #000000 3px 5px;
            .dw{
              font-size: 24px;
              margin-left:16px;
    line-height: 52px;
            }
          }
          }
          .perless{
            font-size: 24px;
            color: #ffffff;
            text-align: left;
            margin:16px 0;
               text-shadow: #000000 3px 5px;
          }
          .alines{
            width: 100%;
            height:10px; 
            background: #ffffff;
            position: relative;
            border-radius: 16px;
            margin-bottom: 28px;
            .act{
              background:linear-gradient(200deg, #12c2fc 0%, #3ae2f8 31%, #14a5d0 49%, #441dda 79%, #0017ff 100%);
              height: 10px;
              position:absolute;
                 border-radius: 16px;
              left:0;
              top:0;
              width:0%;
            }
            
          }
        .cont{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left{
            font-size: 24px;
            color: #FFFFFF;
            opacity: 0.6;
          }
          .right{
            .sinput{
              width:auto;
              padding: 5px 40px;
              border-radius: 100px;
              height: 64px;
              background: #181818;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              box-sizing: border-box;
              .txt{
                color: #ddd7d7;
                margin-right: 16px;
                font-weight: bold;
                font-size:26px;
              }
              .num{
                color: #ffffff;
                font-size: 32px;
                font-weight: bold;
                margin-right: 16px;
              }
            }
          }
          .lpbox{
              display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            border:1px solid #35dcf7;
            border-radius: 20px;
            height: 84px;
            padding: 8px 20px 8px 30px;
            box-sizing: border-box;     
            margin:24px 0 12px;   
            background:linear-gradient(135.46deg,rgba(6,6,6,.5) 24.8%,rgba(32,32,32,.5) 57.07%);// linear-gradient(135.46deg, rgba(6, 6, 6, 0.5) 24.8%, rgba(32, 32, 32, 0.5) 57.07%);
            // background:#00000070 url("../assets/img/sbg.png") no-repeat ; 
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);   
            .laber{
              color: #ffffff;
                font-size: 24px;
                margin-right: 16px;
            }
            .nums{
                display: flex;
              align-items: center;
              .tt{
                font-size: 32px;
        font-family: $t-f;
        font-weight: bold;
          background: linear-gradient(90deg, #6cd0cb 0%, #71c5ed 51%, #0695a3 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0 10px;
              }
              .ico{
                width: 28px;
                height: 28px;
              }
            }
          }
          .input{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            background: #2A2A2A;
            border-radius: 100px;
            height: 84px;
            padding: 8px 20px 8px 30px;
            box-sizing: border-box;     
            margin: 32px 0;       
            .yinput{
              border: none;
              background: transparent;
              color: #ffffff;
              font-size: 32px;
              font-weight: bold;
              width: calc(100% - 100px)
            }
            .dw{
              display: flex;
              align-items: center;
              .tt{
                color: #ffffff;
                font-size: 28px;
                font-weight: bold;
                margin:  0 10px;                
                white-space: nowrap;
              }
              .ico{
                width: 40px;
                height: 40px;
              }
            }
          }
          .icos{
            font-size: 18px;
            color: #ffffff;
            .ico{
                width: 40px;
                height: 40px;
                border: 1px solid #ffff;
    border-radius: 100%;
              }
          }
          .rbox{
            display: flex;
            align-items: center;
            justify-content: center;
            .num{
          //  margin: 22px auto;
        font-size: 38px;
        font-family: $t-f;
        font-weight: bold;
          background: linear-gradient(90deg, #6cd0cb 0%, #71c5ed 51%, #0695a3 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        .dw{
             background: #ffffff;
            -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
                font-size: 20px;
                margin:  0 10px;
        }
        }
            .txt{
              color: #ffffff;
                font-size: 20px;
                // font-weight: bold;
                margin:  0 10px;
                // 
                text-align: right;
            }
            .mm{
min-width: 52px;
            }
            .ico{
              width: 40px;
              height: 40px;
            }
          }

         
          .ibox{
            border: 1px solid #353535 ;
            border-radius: 40px;
            width: 100%;
            margin-top: 40px;
            padding: 30px 40px;
            box-sizing: border-box;
            background:linear-gradient(135.46deg,rgba(6,6,6,.5) 24.8%,rgba(32,32,32,.5) 57.07%);// linear-gradient(135.46deg, rgba(6, 6, 6, 0.5) 24.8%, rgba(32, 32, 32, 0.5) 57.07%);
            // background:#00000070 url("../assets/img/sbg.png") no-repeat ; 
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);  
            .txts{
              color: #ffffff;
              font-size: 24px;
              margin-bottom: 20px;
            }
            .jz{
              color: #b5b4b4;
              font-size: 24px;
              margin: 20px 0 10px;
            }
          }
          .brlu{
            border:1px solid #35dcf7;
          }
          .btnr{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            .btn{
          background: #2A2A2A;
            color: #ABABAB;
            border: none;
            border-radius: 100px;
            height: 68px;
            width: 250px;
            font-size: 24px;
            font-weight: bold;
            margin-left: 10px;
          }
        .act{
          color: #ffffff;
          background: linear-gradient(188.1deg, #178caa 18.52%, #28c0de 71.67%);
            //
        }
          }
          .btngroup{
            display: flex;
            align-items: center;
            margin-top: 20px;
            .btns{
              background:  linear-gradient(188.1deg, #178caa 18.52%, #28c0de 71.67%);
              color: #ffffff;
              border-radius: 56px;
              font-size: 28px;
              height: 52px;
              line-height: 52px;
              flex:1;
              border: 1px solid #2A2A2A;
            }
            .btn{
              background: transparent;
              color: #ffffff;
              border-radius: 56px;
              font-size: 28px;
              height: 52px;
              line-height: 52px;
              flex:1;
              border: 1px solid #35dcf7;
              margin-left: 20px;
            }
          }

        }
      }
      .yqbox{
          .link{
            margin:40px 26px 20px;
            font-size: 28px;
            white-space: normal;
            word-break: break-all;
            // background: linear-gradient(188.1deg, #178caa 18.52%, #28c0de 71.67%);
            background: linear-gradient(90deg, #1cc7f8 18.52%, #00e7ff 71.67%);
            // background: linear-gradient(to right, #C373FA, #8DBFEF); /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
				-webkit-background-clip: text;/*将设置的背景颜色限制在文字中*/
				-webkit-text-fill-color: transparent;/*给文字设置成透明*/
        }
      }
      .buttom{
        display: flex;
        width: 100%;    
        margin: 30px auto;  
        .btn{
         background: #2A2A2A;
          color: #ABABAB;
          border: none;
          border-radius: 100px;
          height: 68px;
          width: 100%;
          font-size: 24px;
          font-weight: bold;
        }
        .act{
          color: #ffffff;
          background:  linear-gradient(188.1deg, #178caa 18.52%, #28c0de 71.67%);
        }
        .btns{
          color: #ffffff;
          height: 68px;
          width: 100%;
          font-size: 28px;
          font-weight: bold;
        }
      }
        
       

       .imggrop{
          display: flex;
          align-items: center;
          justify-content: center;
          .im1{
            width: 144px;
            height: 144px;
            z-index: 2;
            
          }.im2{
             width: 144px;
            height: 144px;
            margin-left: -60px;
            z-index: 1;
          }
        }
        .ttx{
          font-size: 36px;
          font-family: $t-f;
          font-weight: 600;
          color: #ffffff;
          line-height: 50px;
          text-align: center;
        }
      
        
      .sbot {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        flex: 1;
        width: 100%;
        text-align: center;
        margin: 24px 0;
          .txt {
            height: 56px;
            font-size: 46px;
            font-family: $t-mf;
            font-weight: 600;
            line-height: 54px;
            text-align: center;
            font-size: 56px;
            color: #ffffff;
          }
          .btn {
            background: #ffffff;
            // box-shadow: 0px 4px 16px 4px rgba(207,182,247,1);
            // border-radius: 40px;
            font-size: 32px;
            font-family: $t-f;
            font-weight: 600;
            color: #000000;
            line-height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            width: 280px;
height: 80px;
          }
      }
      .title{
        font-size: 36px;
font-family: $t-f;
font-weight: 600;
color: #000000;
line-height: 50px;
text-align: left;
      }
       .lines {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        flex: 1;
        width: 92%;
        text-align: center;
        margin: 37px auto;
        .item {
          text-align: center;
          flex: 1;
          
          .txt1 {
            height: 54px;
            font-size: 28px;
            font-family: $t-f;
            font-weight: bold;
            line-height: 54px;
            text-align: center;
            color: #000000;
            white-space: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
          }
          .txt2 {
            height: 40px;
            font-size: 28px;
            font-family: $t-mf;
            font-weight: 600;
            color: #888888;
            line-height: 40px;
            text-align: center;
            margin-top: 18px;
          }
        }
      }
    }
 .m60{
      margin: 100px 30px 0;
    }
    .bg1{
      
  background:url("../assets/img/bg19.jpg") center no-repeat ; 
    background-size: cover;
   }
    .title{
      font-size: 38px;
      font-weight: bold;
      color: #ffffff;
      margin: 72px auto 72px;
      border-radius: 36px 0 36px 0;
      width: 360px;
      padding: 22px;
      position: relative;
    }
    .m24{
      margin-top:-42px
    }
    .title::after{
      content: "";
      position: absolute;
      height: 4px;
      width: 100px;
      border-radius: 16px;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(200deg, #12c2fc 0%, #3ae2f8 31%, #14a5d0 49%, #441dda 79%, #0b1042 100%);
    }
   
    .linebox{
      display: flex;
      align-items: center;
      justify-content: space-around;
      .card3{
        flex: 1;
        margin: 10px 28px;
        background:#00000070;//#262626;
        // border-radius: 20px;
            border: 1px solid #381b7c;
        // height: 360px;
            display: flex;
    align-items: center;
    justify-content: center;
         .list {
          flex: 1;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        margin: 10px 0 10px;
        padding:20px 0;
        position: relative;
        .she{
          position: absolute;
          right: 10px;
          top: 10px;
          height: 45px;
          width: 45px;
        }
        .item {
          flex: 1;
          overflow: hidden;
          .ico{width: 68px;}
            .num {
        margin-top: 22px;
        font-size: 32px;
        font-family: $t-f;
        font-weight: bold;
         background: linear-gradient(90deg, #6cd0cb 0%, #71c5ed 51%, #0695a3 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: 58px;
        white-space: nowrap;
        overflow-x: auto;
        padding: 0 20px;
        overflow-y: hidden;
      }
      .tt {
        font-size: 28px;
        font-family: $t-mf;
        font-weight: 600;
        color:#ffffff;
        line-height: 40px;
        margin-top: 12px;
      }
          .btn {
           min-width: 280px;         
            background: #000;
            // border-radius: 60px;
            font-size: 32px;
            font-family: $t-mf;
            padding: 10px 20px;
            font-weight: 600;
            color: #ffffff;
            margin: 10px auto;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
             border: 1px solid #381b7c;
             background: linear-gradient(200deg, #12c2fc 0%, #3ae2f8 31%, #14a5d0 49%, #441dda 79%, #0b1042 100%);
            .img{
              height: 32px;
              width: 32px;
              // border-radius: 100%;
              margin-right: 10px;
            }
            .line{
              height: 20px;
              width: 1px;
              background: #b4184c;
              margin:0 20px;
            }
          }
        }
      }
      // .row{
      //   flex-direction: row;
      // }
      }
    }
    .card2 {
      width: 694px;
      height: 100%;
      background:#00000070;// #262626;
      // box-shadow: 0px 4px 16px 8px rgba(227, 224, 224, 0.5);
      // @include box_color("box_color");
          border: 1px solid #381b7c;
      // border-radius: 20px;
      margin: 28px auto;
      padding: 28px 0;
       color:#000;
       
      .ico{
        width: 43px;
        height: 43px;
      }
      .imgroup{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-left: 48px;
        .img{width: 86px;
        height: auto;
          // border-radius: 10px;
        }
      }
      .mytg{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin:0 28px;
      .left{
        display: flex;
        align-items: center;
        .tt{
          margin: 0 10px;
        }
      }
      .right{
       
      }
      }



      .title {
        margin-left: 50px;
        margin-right: 28px;
        height: 66px;
        font-size: 40px;
        font-family: $t-mf;
        font-weight: 600;
        color: #ffffff;
        line-height: 66px;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: center;       
        .node {
          font-size: 30px;
          font-weight: 600;
          color: #8B8B94;
          line-height: 32px;
        }
      }
      .lmtop{
        display: flex;
        justify-content: space-between;
        padding: 20px 32px;
         color:#000000;
        .left{
          display: flex;
          flex-direction: column;
          align-items: center;
          .ilog{
            height: 56px;
            width: 56px;
          }
          .ttx{
            font-size: 24px;
            font-family: $t-f;
           
          }
        }
        .cont{
          height: 76px;
          width: 76px;
        }
        .right{
           display: flex;
          flex-direction: column;
          align-items: center;
          .ilog{
            height: 56px;
            width: 56px;
          }
          .ttx{
            font-size: 24px;
            font-family: $t-f;
          }
        }
      }
      .sinput{
        border-top: 1px dashed #e9e9e9;
        border-bottom:1px dashed #e9e9e9;
        display: flex;
        height: 100px;
        justify-content: space-between;
        align-items: center;
         padding: 10px 32px;
        .left{
          width: 50%;         
         input{
          border: none;
          text-align: left;
          font-family: $t-f;
          background: transparent;
        }
        }
        .right{
          width: 50%;
         input{
          border: none;
          text-align: right;
          font-family: $t-f;
          background: transparent;
        }
        }
      
      }
      .info{
        padding: 10px 32px;
        .tlt{
          font-size: 22px;
          margin: 20px 0;
        }
        .total{
          display: flex;
          align-items: center;
          justify-content: space-between;

        }
      }
      .tips {
        display: flex;
        align-items: center;
        flex-direction: column;

        .cnum {
          font-size: 28px;
          font-family: $t-mf;
          font-weight: 600;
          color: #999999;
          line-height: 40px;
        }
      }

      .cbox{
            margin: 30px;
    padding: 14px 20px;
    position: relative;
    background: #fff;
    box-shadow: inset 0 -2px 8px 0 rgb(51 1 138 / 8%);
    // border-radius: 15px;
    border: 1px solid;
        .tl{
          font-weight: 600;
          font-family: $t-mf;
          font-size: 26px;
          text-align: left;
          color: #333;
        }
        .line{
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 600;
          font-size: 30px;
          font-family: $t-f;
          margin: 40px 10px;
          color:#00023d;
        }

      }

      .num {
        margin-top: 22px;
        font-size: 18px;
        font-family: $t-f;
        font-weight: bold;
        background: linear-gradient(234deg,#e4005e, #b4184c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        // line-height: 58px;
        white-space: nowrap;
        overflow-x: auto;
        padding: 0 20px;
        overflow-y: hidden;
      }
      .tt {
        font-size: 22px;
        font-family: $t-mf;
        font-weight: 600;
        color:#ffffff;
        line-height: 40px;
        margin-top: 12px;
      }
      .gree{
        color: #14f714;
      }
      .red{
        color: #ec2832;
      }
      .sitm{
    background: #313131;
    // border-radius: 10px;
    padding: 10px 0 20px;
    margin: 5px;

    .num{
      overflow: hidden;
      white-space: pre-wrap;
      padding: 0 0 0 10px;
    }
      }
      .bottom{
        margin-top: 64px;
         .btn {
            width: 80%;
            height: 80px;
            // background: #b4184c;
            
          background: #a2a2a9;
// box-shadow: 0px 4px 16px 4px rgba(207,182,247,1);
// border-radius: 40px;
            font-size: 32px;
            font-family: $t-mf;
            font-weight: 600;
            color: #ffffff;
            line-height: 80px;
            margin: 20px auto;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
         }
         .stbn{
            font-size: 30px;
            font-family: $t-f;
            font-weight: 600;
            color: #8B8B94;
            margin: 10px auto;
            line-height: 34px;
         }
      }
      .list {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 24px 0;
        .item {
          // flex: 1;
          overflow: hidden;

          .btn {
            min-width: 100px;  
            max-width: 160px;          
            background: #000;
            // border-radius: 60px;
            font-size: 32px;
            font-family: $t-mf;
            padding: 10px ;
            font-weight: 600;
            color: #ffffff;
            margin: 0 auto;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            .img{
              height: 32px;
              width: 32px;
              // border-radius: 100%;
              margin-right: 10px;
            }
          }
        }
      }

      .jjc {
        line-height: 52px;
        display: flex;
        justify-content: center;
        span:nth-child(1) {
          font-size: 28px;
          font-family: $t-mf;
          font-weight: 600;
          color: #888888;
        }
        span:nth-child(2) {
          font-size: 44px;
          font-family: $t-f;
          font-weight: bold;
          @include font_color("font_color1");
          margin: 0 52px 0 20px;
          max-width: 50%;
          overflow-x: auto;
          display: inline-block;
          overflow-y: hidden;
        }
        span:nth-child(3) {
          font-size: 28px;
          font-family: $t-mf;
          font-weight: 600;
          color: #616161;
        }
      }
      .time {
        margin: 52px auto 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 42px;
          width: 38px;
          margin-right: 12px;
        }
        div {
          font-size: 44px;
          font-family: $t-mf;
          font-weight: bold;
          @include font_color("font_color1");
          line-height: 52px;
        }
      }

      .txt {
        font-size: 28px;
        font-family: $t-mf;
        font-weight: 600;
        color: #616161;
        line-height: 40px;
      }

      .bltitle {
        height: 60px;
        @include background_color("background_color5");
        font-size: 32px;
        font-family: $t-mf;
        font-weight: 600;
        @include font_color("font_color1");
        line-height: 60px;
        margin-top: 69px;
      }
      .list {
        .listtop {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 40px;
          font-size: 28px;
          font-family: $t-mf;
          font-weight: 600;
          color: #616161;
          line-height: 40px;
          padding: 0 52px;
          margin: 25px auto;
          .sort {
            width: 56px;
          }
        }
        .items {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 52px;
          margin: 25px auto;
          .sord {
            font-size: 28px;
            font-family: $t-f;
            font-weight: bold;
            @include font_color("font_color1");
            line-height: 32px;
            width: 56px;
            text-align: center;
          }
          .address {
            span {
              height: 32px;
              font-size: 28px;
              font-family: $t-f;
              font-weight: bold;
              @include font_color("font_color1");
              line-height: 32px;
              margin: 0 13px;
            }
            .fuzhi {
              background: transparent;
              border: none;
              width: 30px;
            }
            img {
              height: 30px;
              width: 28px;
            }
          }
          .num {
            font-size: 28px;
            font-family: $t-f;
            font-weight: bold;
            @include font_color("font_color1");
            line-height: 32px;
          }
        }
      }
      .buttombtn {
        margin: 15px auto 60px;
        width: 152px;
        height: 54px;
        background: #f3f3f3;
        // border-radius: 27px;
        transform: all 0.3;
        span {
          font-size: 28px;
          font-family: $t-mf;
          font-weight: 600;
          color: #aaaaaa;
          line-height: 54px;
          margin: 0 10px;
        }
        img {
          width: 22px;
          height: 14px;
        }
        .sxz {
          transform: rotate(180deg);
        }
      }
    }
    .sbfg{
    //   border: 1px solid #381b7c;
    // background: url("../assets/img/abg.png") 100%/100% no-repeat;
    
background: linear-gradient(200deg, #12c2fc 0%, #3ae2f8 31%, #14a5d0 49%, #441dda 79%, #0b1042 100%);
        display: flex;
    align-items: center;
    justify-content: space-between;
    height: 150px;
    .btn{
      display: flex;
      align-items: center;
      justify-content: flex-end;
        margin:  0 20px;
        min-width: 252px;
        height: 84px;
        line-height: 84px;
        //  background: linear-gradient(18deg, #ffdf2d, #00e2be);
        border: 1px solid #ffffff; 
        // border-radius: 70px;
        padding-left: 20px;
        font-weight: 600;
        font-family: $t-mf;
        overflow: hidden;
        
        .she{
          height: 45px;
          width: 45px;
          margin: 0 30px;
        }
        .tnxt{
          color: #ffffff;
        font-family: $t-mf;
        white-space: nowrap;
             font-size: 36px;
        }
    }
  }
   .card4 {
    width: 652px;
    // background: linear-gradient(18deg, #ffdf2d, #00e2be);
    // border-radius: 20px;
    background: #00000070;
    padding: 20px;
    margin: 20px auto;
border: 1px solid #381b7c;
    .yqlink {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-top: 18px;
      .ltxt {
        font-size: 30px;
        font-family: $t-mf;
        font-weight: 600;
        color: #ffffff;
        line-height: 42px;
      }
      .mylink {
        width: 440px;
        height: 60px;
        background: #f8f8f8;
        // border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 22px;
        .address {
          width: 250px;
          height: 32px;
          font-size: 22px;
          font-family: $t-mf;
          font-weight: 600;
          color: #000000;
          line-height: 32px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .fuzhi {
          background: transparent;
          border: none;
          width: 50px;
        }
        .icon {
          width: 42px;
          height: 42px;
        }
      }
    }
    .tips {
      font-size: 24px;
      font-family: $t-mf;
      font-weight: 400;
      color: #ffffff;
      line-height: 34px;
      text-align: left;
      margin: 22px 0 0;
    }
    .btns {
      width: 638px;
      height: 80px;
      background: #000000;
      // border-radius: 40px;
      font-size: 32px;
      font-family: $t-mf;
      font-weight: 600;
      color: #ffffff;
      line-height: 80px;
      margin: 18px auto 20px;
    }
  }
    .more {
      width: 750px;
      margin: 0 auto;
      .txts {
        height: 56px;
        font-size: 40px;
        font-family: $t-mf;
        font-weight: 600;
       color: #fff;
        line-height: 56px;
        margin: 54px auto;
      }
     .qblist {
        display: flex;
        flex-wrap: wrap;
        margin: 15px;
        .icons {
          width: calc(50% - 32px);
          background: #262626;
          // box-shadow: 0px 4px 16px 8px rgba(227,224,224,0.5);
          // border-radius: 7px;
          // border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: row;
          margin: 16px;
          img {
            width: 84px;
            height: 84px;            
            padding: 16px;
          }
          span {
            height: 44px;
            font-size: 22px;
            font-family: $t-mf;
            font-weight: 600;
            color: #ffffff;
            line-height: 44px;
            cursor: pointer;
            flex: 1;
            text-align: left;
            margin-left: 10px;
          }
        }
      }
    }
    .buttoms {
      height: 28px;
      font-size: 24px;
      font-family: $t-f;
      font-weight: bold;
      color: #999999;
      line-height: 28px;
      margin: 80px auto 160px;
      padding-bottom: 80px;
      
    }
  }
 

  .popup {
    width: 672px;
    background: #ffffff;
    // border-radius: 30px;
        padding: 30px 30px 40px;
        box-sizing: border-box;
    ::v-deep.van-list{
      height: 50vh;
    overflow: auto;
    }
    ::v-deep .van-stepper__input{
          font-size: 42px;
        }
   
    .tips{
      font-size: 28px;
      font-family: $t-mf;
      font-weight: 600;
      color: #999999;
      line-height: 66px;
      margin: 24px auto;
    }
    .inode {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
      background: #f1f1f1;
      // border-radius: 8px;
      margin: 8px 34px;
      padding: 20px 8px;
      font-weight: 400;
      font-size: 28px;
      font-family: $t-f;
      .items{
         display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
      .line{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px ;
        flex: 1;
        .left {
        text-align: left;
          font-size: 22px;
          font-family: $t-mf;
          font-weight: 400;
          color: #999;
          line-height: 32px;
      }
      .right {
        font-size: 22px;
        font-family: $t-f;
        font-weight: 600;
        color: #131415;
        line-height: 32px;
      }
      }}
      .fuzhi {
        background: transparent;
        border: none;
        color: #1755ee;
      }
    }
    .input {
      border: none;
      width: 70%;
      height: 50px;
      background: #f8f8f8;
      // border-radius: 50px;
      margin: 10px auto;
      padding: 10px 20px;
      font-size: 28px;
      // background: transparent;
      
    }
    .bg{
       background: linear-gradient(234deg,#e4005e, #b4184c);
        margin: 20px 34px;
       padding:10px;
       
    // border-radius: 20px;
       
    }
    .logo{
      // height:188px;
      width: 188px;
      margin: 44px auto 20px;
    }
    .item {
     display: flex;
     align-items: center;
     justify-content: space-between;
       background:#262626;
      //  border-radius: 10px;
    padding: 0 10px;
      .txts {
        font-size: 32px;
        font-family: $t-f;
        text-align: right;
        margin: 10px 0;
    font-weight: bold;
    line-height: 54px;
     background: linear-gradient(234deg,#e4005e, #b4184c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .flexs{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 10px 0;
      
        .tts{
           font-size: 28px;
          font-family: $t-mf;
          font-weight: 600;
          @include font_color("font_color1");
          line-height: 40px;
          text-align: left;
          margin: 0 10px ;
          
        }
      }
      .txd{
        margin: 20px 0;
        text-align: left;
        font-size: 24px;
        font-family: $t-f;
        font-weight: 600;
        color: #f8f8f8;
        line-height: 40px;
      }
      .inputs {
        border: none;
        height: 50px;
        width: 100%;
        font-size: 34px;
        font-family: $t-f;
      }
    }
    .txt {
      font-size: 28px;
      font-family: $t-mf;
      font-weight: 400;
      @include font_color("font_color1");
      line-height: 40px;
      margin: 10px 106px;
      text-align: left;
    }
      .top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 32px;
            .close{
                width:28px;
            }
             .title{
            width: 100%;
            font-size:32px;
            font-weight: bold;
            color: #000000;
            text-align: left;
           
        }
        }
         .sqtxts{
      font-size: 24px;
      font-family:$t-f;
      font-weight: 600;
      color: #848484;
      line-height: 44px;
      margin: 10px 0 45px;
      padding: 0 22px;
      box-sizing: border-box;
      text-align: left;
    }
    .sqtxt{
      font-size: 32px;
      font-family:$t-f;
      font-weight: 600;
      color: #848484;
      line-height: 44px;
      margin: 10px 0 45px;
      padding: 0 22px;
      box-sizing: border-box;
    }
    .xbox{
       background: #F3F0F4;
            padding: 10px 20px;
            border-radius: 36px;
             display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 16px auto;
              .num{
          //  margin: 22px auto;
        font-size: 24px;
        font-family: $t-f;
        font-weight: bold;
          background: linear-gradient(34deg, #1fa391, #28514b);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        }
            .txt{
              color: #2A2A2A;
                font-size: 24px;
                font-weight: bold;
                margin:  0 10px;
            }
    }
    .rbox{
            display: flex;
            align-items: center;
            justify-content: center;
           
            .num{
          //  margin: 22px auto;
        font-size: 42px;
        font-family: $t-f;
        font-weight: bold;
          background: linear-gradient(234deg, #106156, #cc1d1d);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        .dw{
             color: #2A2A2A;
                font-size: 24px;
                font-weight: bold;
                margin:  0 10px;
        }
        }
            .txt{
              color: #2A2A2A;
                font-size: 24px;
                font-weight: bold;
                margin:  0 10px;
            }
            .ico{
              width: 40px;
              height: 40px;
            }
          }
     .box{
          color: #2A2A2A;
                font-size: 26px;
                font-weight: bold;
                margin: 10px;
                text-align: left;
                line-height: 36px;

     }    
     .tt{
      color: #5c5b5b;
                font-size: 22px;
                font-weight: bold;
                margin: 10px;
                text-align: right;
     } 
     .time{
      color: #5c5b5b;
                font-size: 22px;
                font-weight: bold;
                text-align: right;
                margin:  10px;
     }
    .flsz{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .cnet{
      text-align: center;
      font-size: 46px;
    }
    .btn {
     width: calc(100% - 200px);
      height: 80px;
      font-size: 32px;
      font-family: $t-mf;
      font-weight: 600;
      color: #ffffff;
      line-height: 80px;
      margin: 54px auto;
background: linear-gradient(90deg, #F83AFD 0%, #C333FF 31%, #A84BFF 49%, #724EFF 79%, #495AFA 100%);
box-shadow: 0px 4px 16px 4px rgba(207,182,247,1);
border-radius: 40px;
border: none;
  display: flex;
      align-items: center;
      justify-content: center;
    }
     .btns {
      width: 480px;
      height: 80px;
      font-size: 32px;
      font-family: $t-mf;
      font-weight: 600;
      color: #ffffff;
      line-height: 80px;
      margin: 54px auto;
background: linear-gradient(90deg, #F83AFD 0%, #C333FF 31%, #A84BFF 49%, #724EFF 79%, #495AFA 100%);
box-shadow: 0px 4px 16px 4px rgba(207,182,247,1);
// border-radius: 40px;
border: none;
  display: flex;
      align-items: center;
      justify-content: center;
    }
    .nbtn{
      width: 100%;
      height: 80px;
box-shadow: 0px 4px 16px 4px rgba(227,211,253,1);
// border-radius: 40px;
border: 2px solid rgba(115, 40, 236, 0.5);
font-size: 32px;
font-family: $t-f;
margin: 54px 20px;
font-weight: 600;
color: #b4184c;
line-height: 44px;
  display: flex;
      align-items: center;
      justify-content: center;
    }
    .lang {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 50px auto;
      img {
        height: 50px;
        width: 50px;
      }
      span {
        font-size: 28px;
        font-family: $t-mf;
        font-weight: 400;
        @include font_color("font_color1");
        line-height: 40px;
      }
    }
 
  }
  .usIcon{
     display: flex;
    align-items: center;
    justify-content: center;
    margin-top:188px;
    .icon{
      margin:20px;
      width:58px;
      height:58px;
      .ico{
        width:58px;
      height:58px;
      }
    }
  }
 
  .flexbottom{
    position: fixed;
    bottom: 0;
    width: 750px;
    height: 160px;
    background: linear-gradient(18deg, #ffdf2d, #00e2be);
    z-index: 99;
    // border-radius: 50% 50% 0 0;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .txt{
    font-size: 28px;
    font-weight: 600;
    font-family: $t-f;
    line-height: 42px;
    }
  }
   .infos{
        font-size: 28px;
        font-weight: 600;
        font-family: $t-mf;
        text-align: justify;
        background: #000000;
        display: flex;
        height: 100vh;
        width: 100vw;
        overflow: hidden;
      .video{
        width: 100%;
        height: 100vh;
      }
      }
}
</style>
